<template>
  <div>
    <div class="text-h6">Category</div>
    <v-btn
      text
      class="pl-0 mt-4"
      @click="back"
    >
      &lt; Back
    </v-btn>
    <v-row>
      <v-col
        cols="12"
        md="3"
      >
        <CategoryEdit />
      </v-col>
      <v-col
        cols="12"
        md="9"
      >
        <ProductsList :category-id="id" />
        <v-row dense>
          <v-col class="text-h6"> Sub-Categories </v-col>
          <v-col cols="12">
            <CategoryList :parent-id="id" />
          </v-col>
        </v-row>
        <DesignGroupTree />
      </v-col>
    </v-row>
  </div>
</template>

<script>
import CategoryEdit from '@/components/categories/Edit';
import CategoryList from '@/components/catalog/Categories';
import ProductsList from '@/components/products/List';
import DesignGroupTree from '@/components/categories/DesignGroupTree';

export default {
  name: 'CategoryDetail',

  components: {
    CategoryEdit,
    CategoryList,
    ProductsList,
    DesignGroupTree
  },

  computed: {
    id() {
      return parseInt(this.$route.params.id);
    }
  }
};
</script>
